export default __webpack_public_path__ + "static/media/rows.f76f1175.svg";